class SiteVersionLabelController {
  constructor(
    $interval,
    AppVersionService,
    LogService
  ) {
    "ngInject";
    this.$interval = $interval;
    this.AppVersionService = AppVersionService;
    this.LogService = LogService;
  }

  $onInit() {
    const delay = 1000 * 60;
    this.$interval(() => {
      // No-op to update scope
    }, delay);
  }

  get appVersion() {
    return this.AppVersionService.appVersion;
  }

  get appNameTranslationKey() {
    return this.AppVersionService.appNameTranslationKey;
  }

  get shortVersionInfo() {
    return this.AppVersionService.shortAppVersionInfo;
  }

  get fullVersionInfo() {
    return this.AppVersionService.extendedAppVersionInfoWithAge;
  }
}

export default SiteVersionLabelController;
